import { createServerFn } from "@tanstack/react-start";
import { buildTaxonomy, buildTopicCluster, type TopicCluster } from "@/lib/taxonomy.server";

export type { TopicCluster, ClusterItem, ClusterKind } from "@/lib/taxonomy.server";

export const getTaxonomy = createServerFn({ method: "GET" }).handler(
  async (): Promise<TopicCluster[]> => buildTaxonomy(6),
);

export const getTopicCluster = createServerFn({ method: "GET" })
  .inputValidator((d: { slug: string }) => ({ slug: String(d?.slug ?? "").slice(0, 80) }))
  .handler(async ({ data }): Promise<TopicCluster | null> => buildTopicCluster(data.slug, 24));
